import {IProtocolStep} from "../../types/protocol";
import {FileSelector} from "../../../common/components/FileSelector";
import React from "react";
import {useNeurotuneStore} from "../../../common/store/neurotune";
import {useProtocolStore} from "../../store/protocols";
import {IRawFile, TSubjectId} from "../../../common/types";
import {FileWithPath} from "@mantine/dropzone";


export interface StepFileManagerProps {
    subjectId: TSubjectId
    step: IProtocolStep
    disabled?:boolean
}

export const StepFileManager: React.FC<StepFileManagerProps> = ({subjectId, step, disabled=false}) => {
    const activeCompany = useNeurotuneStore((state) => state.activeCompany)
    const addStepFiles = useProtocolStore((state) => state.addStepFiles)
    const deleteStepFile = useProtocolStore((state) => state.deleteStepFile)


    const onFileSelected = (files: Array<FileWithPath>) => {
        return addStepFiles(activeCompany.id, subjectId, step, files)
    }
    const onDelete = (file: IRawFile) => {
        return deleteStepFile(activeCompany.id, step.protocolId, step.id, file.id)
    }
    const stepFiles = step.transient?.fileData?.files
    const stepFileProgress = step.transient?.fileData?.uploadProgress

    return (<FileSelector style={{display: "grid", grid: "auto / auto", width: "100%"}} mih={"5rem"}
                          multiple={true}
                          activateOnClick={(!stepFiles || stepFiles.length === 0) && ((!stepFileProgress || Object.keys(stepFileProgress || {}).length === 0))}
                          disabled={disabled}
                          onDrop={onFileSelected}
                          accept={[]}
                          files={stepFiles}
                          uploads={stepFileProgress}
                          onDelete={onDelete}
        />
    )
}